import type { ReactNode } from 'react';
import './mentionEmail.css';

export interface MentionComposePanelProps {
  hintMessage?: string | null;
  showPicker?: boolean;
  picker?: ReactNode;
}

/** Hint + mention list anchored above the compose field (chat or textarea). */
export function MentionComposePanel({ hintMessage, showPicker, picker }: MentionComposePanelProps) {
  const showHint = Boolean(hintMessage);
  if (!showHint && !showPicker) return null;

  return (
    <div className="file-review-mention-compose-panel" role="region" aria-label="Mention assist">
      {showPicker ? picker : null}
      {showHint ? (
        <div className="file-review-mention-compose-panel__hint" role="status">
          {hintMessage}
        </div>
      ) : null}
    </div>
  );
}
